import { useEffect, useRef, useState } from "react";

const HIGHLIGHT_MS = 8000;

/**
 * True for a few seconds after `count` goes up, so the UI can draw the eye to it. Nothing before `ready` (the first
 * load going from 0 to however many exist is not news), and `dismiss` ends it early, e.g. once the user opened the list.
 */
export const useCountIncrease = (count: number, ready: boolean) => {
  const previous = useRef<number | null>(null);
  const timer = useRef<ReturnType<typeof setTimeout>>();
  const [highlighted, setHighlighted] = useState(false);

  useEffect(() => {
    if (!ready) return;
    if (previous.current !== null && count > previous.current) {
      setHighlighted(true);
      clearTimeout(timer.current);
      timer.current = setTimeout(() => setHighlighted(false), HIGHLIGHT_MS);
    }
    previous.current = count;
  }, [count, ready]);

  useEffect(() => () => clearTimeout(timer.current), []);

  return {
    highlighted,
    dismiss: () => {
      clearTimeout(timer.current);
      setHighlighted(false);
    },
  };
};
